// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "test",
    "accountName": "development",
    "api_url": "https://ohcasu12jh.execute-api.eu-west-1.amazonaws.com/test/graphql",
    "notifications_api_url": "https://ohcasu12jh.execute-api.eu-west-1.amazonaws.com/test/notifications",
    "run_daily_test_url": "https://sadroeq8df.execute-api.eu-west-1.amazonaws.com/test/run-daily-test",
    "sport_highlights_url": "https://r365vowf6ngmxnnrthbo3spcxe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://ohcasu12jh.execute-api.eu-west-1.amazonaws.com/test/getConfig",
    "direct_appconfig_url": "https://ks5qi8b3ha.execute-api.eu-west-1.amazonaws.com/test",
		"endpoint_url" : "https://ohcasu12jh.execute-api.eu-west-1.amazonaws.com/test",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_GETV6QTvC",
    "aws_user_pools_web_client_id": "3qjcrnj8q2dcoios7dntl43j5c",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-test.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.test.spex-dev.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.test.spex-dev.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "",
    "arcusLicenseAcquisitionEndpointUrl": "https://7p3ij0h3x0.execute-api.eu-west-1.amazonaws.com/test"
};

export default awsConfig;

